import { Vector3 } from '@babylonjs/core';
import { EnemyDistributionConfig } from '../EnemyGenerator';
import { EnemyAttackBehavior } from './EnemyAttackBehavior';
import { EnemyBehavior } from './EnemyBehavior';
import { EnemyChargeJumpBehavior } from './EnemyChargeJumpBehavior';
import { EnemyChaseBehavior } from './EnemyChaseBehavior';
import { EnemyCircleBehavior } from './EnemyCircleBehavior';
import { EnemyFloatingBomberBehavior } from './EnemyFloatingBomberBehavior';
import { EnemyIdleBehavior } from './EnemyIdleBehavior';
import { EnemyJumpBehavior } from './EnemyJumpBehavior';
import { EnemyMimicBehavior } from './EnemyMimicBehavior';
import { EnemyPatrolBehavior } from './EnemyPatrolBehavior';
import { EnemySnipeBehavior } from './EnemySnipeBehavior';
import { EnemyTeleportBehavior } from './EnemyTeleportBehavior';

/**
 * Factory function to create the appropriate behavior for a distribution config
 */

export function createEnemyBehavior(config: EnemyDistributionConfig, startPosition: Vector3): EnemyBehavior {
  config.speed = config.speed ?? 2;
  config.patrolWidth = config.patrolWidth ?? 5;
  config.detectionRange = config.detectionRange ?? 10;
  config.circleRadius = config.circleRadius ?? 3;
  config.jumpHeight = config.jumpHeight ?? 1;
  config.attackRange = config.attackRange ?? 2;
  config.floatHeight = config.floatHeight ?? 3;
  config.floatRadius = config.floatRadius ?? 2;
  config.floatSpeed = config.floatSpeed ?? 0.5;
  config.bombInterval = config.bombInterval ?? 3;
  config.bombScale = config.bombScale ?? 2;

  switch (config.behavior) {
    case 'idle':
      return new EnemyIdleBehavior(startPosition, config);

    case 'patrol':
      return new EnemyPatrolBehavior(startPosition, config);

    case 'chase':
      return new EnemyChaseBehavior(startPosition, config);

    case 'circle':
      return new EnemyCircleBehavior(startPosition, config);

    case 'jump':
      return new EnemyJumpBehavior(startPosition, config);

    case 'attack':
      return new EnemyAttackBehavior(startPosition, config);

    case 'floatingBomber':
      return new EnemyFloatingBomberBehavior(startPosition, config);

    case 'snipe':
      return new EnemySnipeBehavior(startPosition, config);

    case 'teleport':
      return new EnemyTeleportBehavior(startPosition, config);

    case 'chargeJump':
      return new EnemyChargeJumpBehavior(startPosition, config);

    case 'mimic':
      return new EnemyMimicBehavior(startPosition, config);

    default:
      return new EnemyIdleBehavior(startPosition, config);
  }
}
